import { h } from "preact";

import { classNames, renderIcon } from "../helpers";

export default function HintCard({
  buttons,
  children,
  color,
  icon,
  taskPage,
  title,
}) {
  return (
    <div
      class={classNames(
        "hintCard",
        taskPage && "hintCard--taskPage",
        !icon && "hintCard--no-icon",
        color && `hintCard--${color}`
      )}
    >
      <div class="hintCard__side">{icon && renderIcon(icon)}</div>
      <div class="hintCard__content">
        <p class="hintCard__title">{title}</p>
        <p class="t-body3">{children}</p>
      </div>
      {buttons && <div class="hintCard__actions">{buttons}</div>}
    </div>
  );
}
